module.exports = __webpack_public_path__ + "img/transfer21.0767cabd.jpeg";